import { useMemo } from 'react';
import { useSelector } from "react-redux";
import { selectFollowingTeams } from '@features/whereabouts/store/followingTeamsAndTags.duck';
import { selectCurrentUser } from '@shared/store/auth.duck';

export function WithFollowedTeams() {
  const followedTeams = useSelector(selectFollowingTeams);
  const currentUser = useSelector(selectCurrentUser);

  return useMemo(() => {
    return followedTeams.filter(Boolean).map((t) => t.id === currentUser?.teamEntity?.id ? ({...t, name: `My team (${t.name})` }) : t);
  }, [followedTeams, currentUser]);
}
